import React from 'react';
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/footer/Footer';

const Discord = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#121212',
        color: '#fff',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <Navbar />
      <main
        style={{
          flex: '1',
          display: 'flex',
          flexDirection: 'column',
          padding: '20px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            maxWidth: '800px',
            margin: '0 auto',
            textAlign: 'center',
            textShadow: '0 2px 5px rgba(0, 0, 0, 0.7)',
          }}
        >
          <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#FFD700' }}>Welcome to Power Games</h1>
          <p style={{ fontSize: '1.2rem', lineHeight: '1.6', color: '#E0E0E0' }}>
            We are thrilled to announce the upcoming launch of our Minecraft server! Our community is buzzing with anticipation as we prepare an immersive gaming experience tailored just for you. 
            <br />
            While our main Minecraft server is still under construction, we're actively building our Discord server where you can connect with fellow players. 
            <br />
            Join our Discord waiting server <a href="YOUR_DISCORD_INVITE_LINK" target="_blank" rel="noopener noreferrer" style={{ color: '#FFD700', textDecoration: 'underline' }}>here</a> to receive the latest updates and interact with other players. 
            <br />
            Additionally, we are looking for enthusiastic volunteers to help shape our community and server. Join us on this adventure—it's a no-salary position, but the rewards are immense!
          </p>
        </div>
        <div
          style={{
            width: '100%',
            position: 'relative',
            overflow: 'hidden',
            height: '300px',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
            marginTop: '20px',
          }}
        >
          <img
            src="/Discord.png"
            alt="Discord"
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: '0',
              left: '0',
              opacity: '1',
              transition: 'opacity 0.5s',
              objectFit: 'cover',
              maskImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)',
              filter: 'blur(3px)',
            }}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Discord;
